import React from 'react';
import { Box, Container, Grid, Skeleton } from '@mui/material';
import StyledBox from 'views/rebranded-module/information-module/AboutUsViewV2/components/HeroSection/HeroSection.styles';

const HeroSectionSkeleton: React.FC = () => {
  return (
    <StyledBox>
      <Box className="HSBGOverlay" />
      <Box className="HSBGPattern" />
      <Container maxWidth="xl" className="HSContainer">
        {/* Page Title Skeleton */}
        <Skeleton variant="text" width={300} height={48} sx={{ mb: 4, mx: 'auto' }} />

        <Grid container spacing={5} className="HSGrid">
          {/* Left Column - Text Content */}
          <Grid item xl={6} lg={6} md={12} sm={12} className="HSTextColumn">
            {/* Heading Line 1 */}
            <Skeleton variant="text" width="70%" height={32} sx={{ mb: 1 }} />
            {/* Heading Line 2 */}
            <Skeleton variant="text" width="85%" height={40} sx={{ mb: 3 }} />

            {/* Paragraphs */}
            <Box>
              <Skeleton variant="text" width="100%" height={24} />
              <Skeleton variant="text" width="98%" height={24} />
              <Skeleton variant="text" width="95%" height={24} />
              <Skeleton variant="text" width="90%" height={24} />
              <Skeleton variant="text" width="100%" height={24} />
              <Skeleton variant="text" width="98%" height={24} />
              <Skeleton variant="text" width="70%" height={24} />
            </Box>
          </Grid>

          {/* Right Column - Image */}
          <Grid item xl={6} lg={6} md={12} sm={12} className="HSImageColumn">
            <Box className="HSImageContainer">
              <Skeleton variant="rectangular" width="100%" height={355} />
            </Box>
          </Grid>
        </Grid>
      </Container>
    </StyledBox>
  );
};

export { HeroSectionSkeleton };
